import { render, staticRenderFns } from "./pledgePowerRecord.vue?vue&type=template&id=1b8f7927&"
import script from "./pledgePowerRecord.vue?vue&type=script&lang=js&"
export * from "./pledgePowerRecord.vue?vue&type=script&lang=js&"
import style0 from "./pledgePowerRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports